import breakpointChecker from './aboutSlider';

document.addEventListener('DOMContentLoaded', () => {
  // About
  breakpointChecker();
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/about/about.js